export class SIQOfflineBannerTheme {
  textColor = "null";
  backgroundColor = "null";
}
//# sourceMappingURL=SIQOfflineBannerTheme.js.map